module.exports = __webpack_public_path__ + "static/media/Lindö soffa med öppet avslut tyg Elsa beige 02 ben ek detalj 2025 15.a8275099.jpg";